import { map } from "lodash";
import { PropTypes } from "prop-types";
import { Component } from "react";
import { Link } from "react-router";

import Table from "../../Common/Tables/BaseTable";

import sitePaths from "../../../constants/sitePaths";
import { toNorwegianDatetime } from "../../../utils/date";
import rapporterSitePaths from "src/constants/SitePaths/rapporterSitePaths";

class VentilstillingList extends Component {
  static propTypes = {
    ventilstillinger: PropTypes.array,
    id: PropTypes.string,
  };

  header = [
    "Dato",
    "Hovedgate",
    "Tjenestenr.",
    "Kjennemerke",
    "Ileggelse",
    "Lukket",
  ];

  render() {
    const { id, ventilstillinger } = this.props;

    return (
      <div className="table-wrapper-horizontal-scroll">
        <Table headerRow={this.header} id={id} striped>
          <tbody>
            {map(ventilstillinger, (ventilstilling, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Link
                      to={rapporterSitePaths.ventilstillinger.detalj.getUrl(
                        ventilstilling.id,
                      )}
                    >
                      {toNorwegianDatetime(ventilstilling.dato).format(
                        "DD.MM.YYYY",
                      )}
                    </Link>
                  </td>
                  <td>
                    {`${
                      ventilstilling.gatenavn ? ventilstilling.gatenavn : ""
                    } ${
                      ventilstilling.gatenummer ? ventilstilling.gatenummer : ""
                    }`}
                  </td>
                  <td>{ventilstilling.tjenesteNummer}</td>
                  <td>{ventilstilling.kjennemerke}</td>
                  <td>
                    {ventilstilling.ileggelsesnummer && (
                      <Link
                        to={sitePaths.rapporter.ventilstillinger.ileggelse.detalj.getUrl(
                          ventilstilling.ileggelseId,
                        )}
                        style={{ textDecoration: "none" }}
                      >
                        <span>{ventilstilling.ileggelsesnummer}</span>
                      </Link>
                    )}
                  </td>
                  <td>{ventilstilling.isLukket ? "Lukket" : "Aktiv"}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default VentilstillingList;
